import React from "react";
import Header from "../../components/Header";
import { Link } from "react-router-dom";
import Bottombar from "../../components/Bottombar";

function ShowInput() {
  return (
    <div className="flex flex-col dark:bg-black  max-sm:items-center h-screen w-screen  max-sm:justify-center overflow-hidden bg-[#2a71e8]  sm:bg-white ">
      <div className="max-sm:hidden">
        <Header />
      </div>
      <div className=" sm:flex sm:flex-col sm:w-[100%]  grid place-content-center ">
        <h2 className="text-white sm:text-black font-sans font-semibold text-8 dark:text-white mt-[50px]  ml-[110px] sm:mb-14  mb-32">
          Choose Service
        </h2>
        <div className="items-center justify-center   w-full  h-72 flex flex-col sm:space-y-20">
          <h2 className="text-white sm:text-black font-sans font-semibold text-8  ml-[100px] mb-14"></h2>

          <div className="sm:flex sm:space-x-20 space-y-14 sm:space-y-0">
            <div className="sm:bg-[#D9D9D9] bg-white h-16 sm:w-[548px]   w-[353px] rounded-[25px] items-center justify-center flex ">
              <Link to="/signlanguagetotext">
                <button className="text-black font-bold  ">
                  SIGN LANGUAGE TO TEXT
                </button>
              </Link>
            </div>

            <div className="sm:bg-[#D9D9D9]  bg-white h-16 sm:w-[548px]   w-[353px] rounded-[25px] items-center justify-center flex ">
              <Link to="/textandspeechtosignlanguage">
                <button className="text-black font-bold  ">
                  TEXT TO SIGN LANGUAGE
                </button>
              </Link>
            </div>

            <div></div>
          </div>
          <div className="sm:flex  sm:space-x-20 space-y-14 sm:space-y-0">
            <div className="sm:bg-[#D9D9D9] bg-white h-16 sm:w-[548px]  w-[353px] rounded-[25px] items-center justify-center flex">
              <Link to="/signlanguagetotextandspeech">
                <button className="text-black  font-bold ">
                  SIGN LANGUAGE TO SPEECH
                </button>
              </Link>
            </div>

            <div className="sm:bg-[#D9D9D9] bg-white  h-16 sm:w-[548px]  w-[353px]   rounded-[25px] items-center justify-center flex">
              <Link to="/SpeachToSignLanguage">
                <button className="text-black font-bold  ">
                  SPEECH TO SIGN LANGUAGE
                </button>
              </Link>
            </div>

            <div></div>
          </div>
        </div>
      </div>
      <div className="sm:hidden absolute bottom-0 z-40 w-full">
        <Bottombar activeBar={"input"} />
      </div>
    </div>
  );
}

export default ShowInput;
